export const CreationModuleQuestions = [
    {
        header: 'LENKA SE ROZHODLA VSTOUPIT PODÍLEM DO NOVÉHO START-UPU. MŮŽE TO JAKO ZAMĚSTNANEC VYSOKÉ ŠKOLY UDĚLAT?',
        answers: [
            {
                content: 'Může, ale musí kapitálovou účast v jakékoli právnické osobně nahlásit na rektorát do 10 pracovních dnů od doby, kdy k této účasti došlo.',
            },
            {
                content: 'Nesmí – jedná se porušení zákona o střetu zájmu a vysokoškolského zákona.',
            },
            {
                content: 'Může. Pakliže se jedná pouze o kapitálovou účast – Lenka není ani statutárním orgánem ani zaměstnancem této společnosti, tak se na tyto situace nevztahují žádná omezující pravidla.',
                correct: true,
            },
        ],
    },
    {
        header: 'PETR JE STUDENTEM TŘETÍHO ROČNÍKU BAKALÁŘSKÉHO STUDIA NA JEDNÉ Z FAKULT ČVUT. SE SVÝMI SPOLUŽÁKY SI CHCE ZALOŽIT START-UP SPOLEČNOST, S.R.O. JAKÁ JSOU JEHO OMEZENÍ VZHLEDEM K JEHO POSTAVENÍ STUDENTA?',
        answers: [
            {
                content: 'Založení právnické osoby na území EU musí nahlásit v souladu s vysokoškolským zákonem do 30 pracovních dnů na studijní oddělení své fakulty.',
            },
            {
                content: 'Pakliže se jedná o podnikání v oboru, který na vysoké škole studuje, před založením si musí vyžádat povolení od vysoké školy, na které je studentem.',
            },
            {
                content: 'Na Petra si při jeho podnikatelské činnosti nevztahují žádná zásadní omezení, která by se vázala na to, že je studentem vysoké školy. Naopak, z hlediska daňového je možné uplatnit daňové odpočty jako osoba připravující se soustavně na budoucí povolání.',
                correct: true,
            },
        ],
    },
    {
        header: 'JAKÁ MÍSTA JE DŮLEŽITÉ NAVŠTÍVIT, KDYŽ CHCETE ZALOŽIT STAR-UP – NOVOU PRÁVNICKOU OSOBU URČENOU K PODNIKÁNÍ?',
        answers: [
            {
                content: 'Jedná se především o finanční úřad a živnostenský úřad. Další povinnosti se odvíjejí od toho, zda jsou ve společnosti zaměstnanci.',
                correct: true,
            },
            {
                content: 'Je zapotřebí v první řadě získat tzv. IČO od Českého statistického úřadu.',
            },
            {
                content: 'V současné době není nutné nikam chodit. Stačí vyplnit jeden formulář na webu Hospodářské komory a všechny registrace jsou automaticky doručeny na příslušné úřady.',
            },
        ],
    },
    {
        header: 'V ČEM JE ROZDÍL MEZI PODNIKATELEM – PRÁVNICKOU OSOBOU A PODNIKATELEM – FYZICKOU OSOBOU, TZV. IČAŘEM?',
        answers: [
            {
                content: 'Není žádný rozdíl – jako podnikatelé jsou si před zákonem rovni.',
            },
            {
                content: 'Fyzická osoba nemůže být plátcem daně z přidané hodnoty.',
            },
            {
                content: 'Hlavní rozdíl je především v ručení. Zatímco v společnosti s ručením omezeným ručí podílník v podstatě pouze do výše svého vkladu, podnikající fyzická osoba ručí celým svým majetkem.',
                correct: true,
            },
        ],
    },
];
